module.exports = __webpack_public_path__ + "static/media/bedroom.9802398f.png";